import { ITreeControllerDefinition } from '@adaptiva/core/trees';
import { AdministratorMultiTreeController, AdministratorTreeController, AllContentMultiTreeController, ClassPermissionsTreeController, ContentTreeController, EJavaClassNames, GroupMultiTreeController, GroupTreeController, MultiServerObjectTreeController, OfficeTreeController, ServerObjectTreeController } from '@adaptiva/data-service';

export const ADMIN_PORTAL_TREE_CONTROLLERS: ITreeControllerDefinition[] = [
	AdministratorMultiTreeController,
	AdministratorTreeController,
	AllContentMultiTreeController,
	ClassPermissionsTreeController,
	ContentTreeController.extend(EJavaClassNames.AdaptivaPackage),
	GroupMultiTreeController,
	GroupTreeController,
	MultiServerObjectTreeController,
	OfficeTreeController,
	ServerObjectTreeController,
	ServerObjectTreeController.extend(EJavaClassNames.OidcCertificateClient),
];
